import React from 'react';
import PropTypes from 'prop-types';
import { SafetyCertificateFilled } from '@ant-design/icons';

import './ProductOverviewSubscriptionShield.less';

const STATUS_COLOR_MAP = {
  subscribed: 'blue',
  syndicated: 'green',
};

const ProductOverviewSubscriptionShield = ({ product, ...rest }) => {
  let statusKey = product?.subscriptionShield?.toLowerCase();
  const gdsnShieldColour = product?.gdsnShield?.toLowerCase();

  // When the product is received from GDSN (green shield) and it is subscribed,
  // promote the subscription shield to "Syndicated" (the GDSN shield is hidden).
  if (gdsnShieldColour === 'green' && statusKey === 'subscribed') {
    statusKey = 'syndicated';
  }

  const colorClass = STATUS_COLOR_MAP[statusKey] || '';

  return (
    <>
      <div className={`subscription-shield`}>
        <SafetyCertificateFilled
          className={colorClass ? 'subscription-shield--' + colorClass : ''}
        />
      </div>
    </>
  );
};

ProductOverviewSubscriptionShield.propTypes = {
  product: PropTypes.object,
};

export default ProductOverviewSubscriptionShield;
